import { createContext } from "react";
import { useState } from "react";

const ExpertVideosContext = createContext({
  title: '',
  description: '',
  tag: '',
  categoriesIds: [],
  keywords: []
});

export const ExpertVideosProvider = ({ children }) => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [tag, setTag] = useState('');
  const [categoriesIds, setCategoriesIds] = useState([]);
  const [keywords, setKeywords] = useState([]);

  const titleAction = (data) => {
    setTitle(data);
  };

  const descriptionAction = (data) => {
    setDescription(data);
  };

  const tagAction = (data) => {
    setTag(data);
  };

  const categoriesIdsAction = (data) => {
    setCategoriesIds(data);
  };

  const keywordsAction = (data) => {
    const keywordObject = data?.map(keyword => {return {'label': keyword, 'value': keyword}})
    setKeywords(keywordObject);
  };

  const resetExpertVideosContext = () => {
    setTitle('')
    setDescription('')
    setTag('')
    setCategoriesIds([])
    setKeywords([])
  }

  return (
    <ExpertVideosContext.Provider value={{ title, description, tag, categoriesIds, keywords, titleAction, descriptionAction, tagAction, categoriesIdsAction, keywordsAction, resetExpertVideosContext }}>
      {children}
    </ExpertVideosContext.Provider>
  );
};

export default ExpertVideosContext;
